import { CmsService, Page, PageMetaResolver } from '@spartacus/core'
import { combineLatest, Observable } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { CountryService } from '../../site-context/facade/country.service'
import {
  PageRobotsMeta,
  PageRobotsResolver,
  PageTitleResolver,
  TranslationService
} from '@spartacus/core'
import { PageType } from '@spartacus/core'
import { Injectable } from '@angular/core'
import { MbBasePageMetaResolver } from '../../cms/page/mb-base-page-meta-resolver'

@Injectable({
  providedIn: 'root',
})
export class MiltenyiCheckoutPageMetaResolver extends PageMetaResolver implements PageMetaResolver, PageTitleResolver, PageRobotsResolver {
  cmsPage: Observable<Page>

  constructor (public cmsService: CmsService,
               private translation: TranslationService,
               private countryService: CountryService,
               private mbBasePageMetaResolver: MbBasePageMetaResolver) {
    super()
    this.cmsPage = cmsService.getCurrentPage()
    this.pageType = PageType.CONTENT_PAGE
    this.pageTemplate = 'MiltenyiMultiStepCheckoutSummaryPageTemplate'
  }

  resolveTitle (): Observable<string> {
    return combineLatest([this.cmsPage, this.countryService.getActiveCountryNameInNatLang()]).pipe(
      switchMap(([page, activeName]) => this.translation.translate('pageMetaResolver.checkout.mbTitle', {
          title: page?.title,
          countryName: activeName
        })
      ))
  }

  resolveRobots (): Observable<PageRobotsMeta[] | undefined> {
    return this.mbBasePageMetaResolver.resolveRobots()
  }
}
